import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function ShareableListsFeatureGate(props: Props) {
    const {isOpen, onClose} = props;

    return (
        <FeatureGateModalWrapper
            title='Share customized People lists with your team'
            description='Create and share customized lists to keep your team connected to the information they need.'
            bullets={[
                'Create lists by location, industry, or other details that best suit your team’s needs.',
                'Apply specific filters and columns for easy access to essential contacts and updates.',
                'Share these customized lists with your team members so they can access and use them right away.',
            ]}
            feature='sharableListsReports'
            isOpen={isOpen}
            onClose={onClose}
        />
    );
}
